import QueryString from 'qs';
import history from 'src/history';

export const getRandomId = () =>
  Math.floor(Math.random() * Math.floor(Math.random() * Date.now()));

export const getUrlParams = (search?: string): Record<string, any> =>
  QueryString.parse(search ?? history.location.search, {
    ignoreQueryPrefix: true,
  });

export const getUrl = (data: Record<string, any>, path?: string) => {
  const params = getUrlParams();

  const urlReadyQuery = QueryString.stringify({
    ...params,
    ...data,
  });

  return `${path ?? history.location.pathname}?${urlReadyQuery}`;
};

export const riskMeter = (score: number) => {
  let meter = 'NA';

  if (score >= 10 && score <= 24) {
    meter = 'low-risk';
  } else if (score >= 25 && score <= 49) {
    meter = 'moderate-risk';
  } else if (score >= 50) {
    meter = 'high-risk';
  }
  return meter;
};
